import { request } from "@/Api"

const getEntityCategories = (categories) => {
    const entityCategories = {}
    categories.forEach((category) => {
        if (category.legal_entity_id in entityCategories) {
            entityCategories[category.legal_entity_id].push(category)
        } else {
            entityCategories[category.legal_entity_id] = [category]
        }
    })
    return entityCategories
}

const getEntityTaxCodes = (taxCodes) => {
    const entityTaxCodes = {}
    taxCodes.forEach((taxCode) => {
        if (taxCode.legal_entity_id in entityTaxCodes) {
            entityTaxCodes[taxCode.legal_entity_id].push(taxCode)
        } else {
            entityTaxCodes[taxCode.legal_entity_id] = [taxCode]
        }
    })
    return entityTaxCodes
}

export async function getTaxCodes() {
    const response = await request.get("accounting-tax-codes")
    return getEntityTaxCodes(response.data)
}

export async function getCategories() {
    const response = await request.get("accounting-accounts")
    return getEntityCategories(response.data)
}